export default {
  SiteBuilder: {
    Buttons: {
      updateCache: 'به روزرسانی کش سایت',
    },
  },
}
